import { createFileRoute } from '@tanstack/react-router'
import MetersPage from "@/views/meters-page";

export const Route = createFileRoute(
  '/_authenticated/_staff/_with_location_switcher/meters/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <MetersPage/>
  )
}
